<template>
  <div>
    <div :class="$style.row">Распознано платежей: {{ resolved.length }} ({{ resolvedSum }} руб.)</div>
    <div :class="$style.row">
      Не распознан: {{ unresolved.length }} ({{ unresolvedSum }} руб.)
      <router-link
        v-if="historyItem.is_save && unresolved.length"
        class="ml-2"
        :to="{ name: 'uc_b_unresolved_payments', query: { fileId: historyItem.file_id } }"
        target="_blank"
      >
        Подробнее
      </router-link>
    </div>
    <div :class="$style.row">Не является платежом: {{ notInvoice.length }}</div>
    <hr :class="$style.hr"/>
    <div :class="$style.row">Обработано: {{ parsedCount }}</div>
    <div :class="$style.row">Ошибок: {{ errorsCount }}</div>

  </div>
</template>

<script>
import _get from 'lodash/get';

export default {
  name:  "ImportResultBankStatement",
  props: ['historyItem'],
  data() {
    return {
      parsedExistVisible: false,
    };
  },
  computed: {
    resolved() {
      return _get(this.historyItem, ['result', 'parsed', 'resolved'], []);
    },
    resolvedSum() {
      return _get(this.historyItem, ['result', 'additional', 'summary', 'resolved'], []);
    },
    unresolved() {
      return _get(this.historyItem, ['result', 'parsed', 'unresolved'], []);
    },
    unresolvedSum() {
      return _get(this.historyItem, ['result', 'additional', 'summary', 'unresolved'], []);
    },
    notInvoice() {
      return _get(this.historyItem, ['result', 'parsed', 'not_invoice'], []);
    },

    parsedCount() {
      const { result: { parsed } } = this.historyItem;
      let total = 0;
      if (!parsed) return total;
      for (let key in parsed) {
        total += parsed[key].length;
      }
      return total;
    },
    errors() {
      return Object.values(this.historyItem.result.errors);
    },
    errorsCount() {
      return this.errors.length;
    },
  },
};
</script>

<style module lang="scss">
.row {
  font-size: 16px;
  margin-bottom: .5em;
}
.hr {
  margin-bottom: .5em;
}
</style>
